import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "favorited_a8bb7608befdfba307d30a839e0a6655",
  "use": "favorited_a8bb7608befdfba307d30a839e0a6655-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"favorited_a8bb7608befdfba307d30a839e0a6655\">\n    <path fill-rule=\"nonzero\" d=\"M9.255 9.067l2.12-4.665a.686.686 0 0 1 1.25 0l2.12 4.665 4.63.421a.686.686 0 0 1 .425 1.166l-3.545 3.567.954 4.962a.686.686 0 0 1-1.03.715l-4.195-2.559-4.198 2.559a.686.686 0 0 1-1.03-.719l.982-4.957L4.2 10.654a.686.686 0 0 1 .425-1.166l4.63-.42z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol